import _ from 'lodash';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import Chip from '@material-ui/core/Chip';
import { TaskStateIcon } from '../../icons';

const TaskStateChip = (props) => {
   const { name, className, disableDelete = false, ...rest } = props;

   const rootClasses = classNames('TaskStateChip', className);

   const caption = name;

   const onDeleteHandler = !disableDelete ? rest.onDelete : undefined;

   return (
      <div className={rootClasses}>
         <Chip icon={<TaskStateIcon />} className={'chip'} label={caption} {...rest} onDelete={onDeleteHandler} />
      </div>
   );
};

export default TaskStateChip;
